export default "__VITE_ASSET__hM0mnyrD__"